import * as Yup from 'yup';
import {FormNameEnum, UploadFormLabelEnum} from '../../enums';
import {errorMessages} from 'utils/constants';
import {IInputFile} from 'models/library/common';
import {IUploadResourceFormBaseValues} from '../../models';
import {getIsDateEarlierFromToday, isValidFormValue, zipMimeType} from 'admin/resources';

export interface IUploadScormFormBaseValues extends IUploadResourceFormBaseValues {
  [FormNameEnum.file]: IInputFile | any;
  [FormNameEnum.knowledgeSkillsAndAbilities]: number[];
  [FormNameEnum.time]: number;
}

export const uploadScormFormBaseValidationSchema = Yup.object().shape({
  [FormNameEnum.file]: Yup.mixed()
    .nullable()
    .required(`You should attach a ${UploadFormLabelEnum.File}!`)
    .test('has-zip-extension', 'Only .zip file extension is allowed!', (file: IInputFile) => {
      const hasFile = !!file;
      if (!hasFile) return true;
      return zipMimeType.includes(file.type);
    }),

  [FormNameEnum.briefDescription]: Yup.string().max(500, 'Brief description should be less than 500 characters!'),
  [FormNameEnum.gradeLevels]: Yup.array().of(Yup.number()),
  [FormNameEnum.programs]: Yup.array().of(Yup.number()),
  [FormNameEnum.pillars]: Yup.array().of(Yup.number()),
  [FormNameEnum.competencies]: Yup.array().of(Yup.number()),
  [FormNameEnum.knowledgeSkillsAndAbilities]: Yup.array().of(Yup.number()),
  [FormNameEnum.languages]: Yup.array().of(Yup.number()).required('You should select at least one language!'),
  [FormNameEnum.expirationDate]: Yup.date()
    .nullable()
    .typeError('Expected date format: (mm/dd/yyyy)')
    .test('is-date-earlier-than-now', 'The selected date should be in the future.', function () {
      const {expirationDate} = this.parent;

      // If the datepicker is cleaned up, then validation is true
      return getIsDateEarlierFromToday(expirationDate);
    }),
  [FormNameEnum.keyTerms]: Yup.string().nullable().max(250, 'Keywords should be less than 250 characters!'),
  [FormNameEnum.learningObjectives]: Yup.string()
    .nullable()
    .max(250, 'Learning objectives should be less than 250 characters!'),
  [FormNameEnum.isAccessibleToStudents]: Yup.boolean()
    .nullable()
    .required('You should choose if this file will be accessible to students!'),
  [FormNameEnum.hasUploadPermissions]: Yup.boolean().test(
    'is-checked',
    'You should accept upload file permissions!',
    function () {
      return isValidFormValue(this.parent.hasUploadPermissions);
    }
  ),
  [FormNameEnum.time]: Yup.number()
    .nullable()
    .min(0, 'Time should be a positive number!')
    .max(1440, 'Time should be a positive number smaller than 1440!'),
  [FormNameEnum.displayName]: Yup.string()
    .nullable()
    .required(errorMessages.requiredWithInputName(`a ${UploadFormLabelEnum.DisplayName}`)),
});
